<!--
 * @Description: In User Settings Edit
 * @Author: your name
 * @Date: 2019-08-26 16:19:23
 * @LastEditTime: 2019-10-18 14:05:55
 * @LastEditors: Please set LastEditors
 -->
<template>
    <el-dialog
            class="selfModal"
            :modal="false"
            :title="userPermissionTypeDialog.promptTittle"
            :close-on-click-modal="false"
            :visible.sync="permissionDialog"
            :before-close="handleDialogClose"
            :width="dialogWidth"
    >
        <div
                v-if="userPermissionTypeDialog.promptType === 'permission'"
                style="width:100%;height:100%;"
        >
            <treeMenu
                    :key="treeKey"
                    ref="treeMenu"
                    initId="0"
                    :isCheckBoxInit="isCheckBoxInit"
                    :checkStrictly="false"
                    :showBox="true"
                    :showArrow="false"
                    :showShadow="false"
                    loadStyle="menuTree"
                    style="width:100%;"
            ></treeMenu>
        </div>
        <div
                v-if="userPermissionTypeDialog.promptType === 'selectUser'"
                style="position:relative;height:100%;"
        >
            <treeMenu
                    :key="treeKey"
                    ref="treeMenu"
                    initId="0"
                    :showBox="false"
                    :showArrow="false"
                    loadStyle="staticLoad"
                    style="width:30%;dispaly:inline-block;"
                    @nodeClick="getNodeId"
            ></treeMenu>
            <div class="selectUser-right">
                <div style="margin-bottom:10px;">
                    姓名：
                    <el-input
                            v-model="userName"
                            placeholder="请输入姓名"
                            style="width:150px;margin-right:10px;"
                            @keyup.enter.native="userSearch"
                    />
                    <el-button type="primary" size="small " @click="userSearch()"
                    ><i class="el-icon-search"></i><span>搜索</span>
                    </el-button>
                    <el-button size="small " @click="clearUserName()"
                    ><i class="el-icon-refresh"></i><span>清空</span>
                    </el-button>
                </div>
                <div style="height:90%;">
                    <el-scrollbar style="height: 80%;">
                        <el-table
                                border
                                class="table-border"
                                ref="multipleRoleUserTable"
                                :data="deptUserData"
                                tooltip-effect="dark"
                                stripe
                                style="width: 100%;"
                                @selection-change="selectionChange"
                                @select="handleSelect"
                                @select-all="allSelectionChange"
                        >
                            <el-table-column
                                    type="selection"
                                    width="55"
                                    align="center"
                            ></el-table-column>
                            <el-table-column
                                    type="index"
                                    label="序号"
                                    width="65"
                                    align="center"
                            ></el-table-column>
                            <el-table-column
                                    prop="name"
                                    label="姓名"
                                    width="120"
                                    align="center"
                                    show-overflow-tooltip
                            >
                            </el-table-column>
                            <el-table-column
                                    prop="type"
                                    label="类型"
                                    align="center"
                                    show-overflow-tooltip
                            >
                                <template slot-scope="scope">
                                    <span v-if=""></span>
                                    {{ dealRoleType(scope.row.type) }}
                                </template>
                            </el-table-column>
                        </el-table>
                    </el-scrollbar>

                    <!-- 分页start -->
                    <div
                            v-if="selectUser.total > 0"
                            style="margin-top: 20px;text-align:right;"
                    >
                        <el-pagination
                                background
                                @size-change="handleSizeChange"
                                @current-change="UserCurrentChange"
                                layout="total,sizes,prev, pager, next"
                                :current-page.sync="selectUser.current"
                                :page-sizes="[10, 20, 50, 100]"
                                :page-size="selectUser.pageSize"
                                :total="selectUser.total"
                        >
                        </el-pagination>
                    </div>
                    <!-- 分页end -->
                </div>
            </div>
        </div>
        <div
                v-if="userPermissionTypeDialog.promptType === 'selectUserType'"
                style="position:relative;height:100%;"
        >
            <treeMenu
                    :key="treeKey"
                    ref="treeMenu"
                    initId="0"
                    :showBox="true"
                    :showArrow="false"
                    loadStyle="staticLoad"
                    style="width:30%;dispaly:inline-block;"
                    @nodeClick="getNodeId"
            ></treeMenu>
            <div class="selectUser-right">
                <el-table
                        border
                        class="table-border"
                        ref="multipleRoleUserType"
                        :data="userTypes"
                        stripe
                        tooltip-effect="dark"
                        style="width: 100%;"
                        @selection-change="userTypeSelectionChange"
                >
                    <el-table-column
                            type="selection"
                            width="55"
                            align="center"
                    ></el-table-column>
                    <el-table-column
                            type="index"
                            label="序号"
                            width="65"
                            align="center"
                    ></el-table-column>
                    <el-table-column
                            prop="label"
                            label="用户类型"
                            align="center"
                            show-overflow-tooltip
                    >
                        <template slot-scope="scope">
                            {{ scope.row.label }}
                        </template>
                    </el-table-column>
                </el-table>
            </div>
        </div>
        <span slot="footer" class="dialog-footer">
      <el-button
              v-if="userPermissionTypeDialog.promptType === 'permission'"
              type="primary"
              @click="modifysubmit()"
      >更 新</el-button
      >
      <el-button
              v-if="userPermissionTypeDialog.promptType === 'selectUser'"
              type="primary"
              @click="updateRoleUser()"
      >确 认</el-button
      >
      <el-button
              v-if="userPermissionTypeDialog.promptType === 'selectUserType'"
              type="primary"
              @click="updateRoleUserType()"
      >确 认</el-button
      >
      <el-button @click="handleDialogClose">关 闭</el-button>
    </span>
    </el-dialog>
</template>
<script>
    import {
        updateRolePermission,
        getDeptUser,
        getRoleUsers,
        saveRoleUsers,
        getRoleUserTypes,
        saveRoleUserTypes
    } from "@/api/system/role";
    import {dealRoleType, dealRoleTypeData, stringToArray} from "@/util/utils";
    import {mapGetters, mapMutations} from "vuex";
    import treeMenu from "@/components/treeMenu/index.vue";

    export default {
        name: "userPermissionType",
        props: {
            type: {
                type: String,
                required: true
            }
        },
        data() {
            return {
                userName: "",
                deptUserData: [],
                selectUser: {
                    current: 1,
                    pageSize: 10,
                    total: 0
                },
                chooseAll: false,
                multipleDeptUser: [],
                preMultipleDeptUser: [],
                currentDeptId: 1,
                selectedRoleUsers: [],
                // selectedRoleUsersArray: [],
                userTypeChecked: [],
                utypesArray: [],
                treeKey: Date.parse(new Date()),
                dealRoleType: dealRoleType,
                dealRoleTypeData: dealRoleTypeData,
                stringToArray: stringToArray,
                dialogWidth: "50%",
                isCheckBoxInit: true,
            };
        },
        components: {treeMenu},
        computed: {
            ...mapGetters([
                "userPermissionTypeDialog",
                "permissionDialog",
                "checkedArray",
                "userTypes"
            ])
        },
        watch: {
            permissionDialog(val) {
                this.treeKey = Date.parse(new Date());
                this.currentDeptId = 1;
                this.$store.commit("clearChecked");
                this.selectedRoleUsers = [];
                this.selectUser.current = 1;
                console.log(333, this.selectUser.current);
                // this.selectedRoleUsersArray=[];
                if (val && this.userPermissionTypeDialog.promptType === "permission") {
                    this.dialogWidth = "500px";
                    this.isCheckBoxInit = true;
                }
                if (this.userPermissionTypeDialog.promptType !== "permission") {
                    this.dialogWidth = "50%";
                }
            }
        },
        created() {
        },
        methods: {
            ...mapMutations({
                setPermissionDialog: "setPermissionDialog",
                setDefaultChecked: "setDefaultChecked"
            }),
            handleDialogClose() {
                this.setPermissionDialog(false);
            },
            modifysubmit() {
                console.log(44, this.checkedArray);
                if (this.checkedArray.length < 1) {
                    this.$message.error("未选择权限不能进行保存！");
                    return;
                }
                const roleId = this.userPermissionTypeDialog.currentRoleId;
                const menuIds = this.checkedArray;
                let query = {roleId, menuIds};
                updateRolePermission(query).then(res => {
                    if (res.data.code == 0) {
                        this.$message.success("修改权限成功");
                        this.$parent.getTableData();
                        this.setPermissionDialog(false);
                    }
                });
            },
            updateRoleUser() {
                const roleId = this.userPermissionTypeDialog.currentRoleId;
                const deptId = this.currentDeptId;
                const all = this.chooseAll;
                const users = this.multipleDeptUser;
                saveRoleUsers({roleId, deptId, all, users}).then(res => {
                    if (res.data.code == 0) {
                        this.$message.success("选择用户成功");
                        this.setPermissionDialog(false);
                    }
                });
            },
            getNodeId(data) {
                this.currentDeptId = data.id;
                this.selectUser.current = 1;
                this.getDeptUserData();
            },
            userSearch() {
                this.selectUser.current = 1;
                this.getDeptUserData();
            },
            clearUserName() {
                this.userName = "";
                this.getDeptUserData();
            },
            handleSelect(selection, row) {
                this.multipleDeptUser = selection;
                // console.log(this.multipleDeptUser.length,this.preMultipleDeptUser.length)
                if (!selection.includes(row)) {
                    const index = this.selectedRoleUsers.findIndex(
                        e => e == String(row.userId)
                    );
                    this.selectedRoleUsers.splice(index, 1);
                    // console.log(index,this.selectedRoleUsers)
                } else {
                    this.multipleDeptUser.forEach((item, index) => {
                        if (!this.selectedRoleUsers.includes(String(item.userId))) {
                            this.selectedRoleUsers.push(String(item.userId));
                        }
                    });
                }
                // console.log("切换选择后",this.selectedRoleUsers)
            },
            selectionChange(val) {
                this.chooseAll && (this.chooseAll = false);
            },
            allSelectionChange(selection) {
                if (selection.length > 0) {
                    this.chooseAll = true;
                    selection.forEach((item, index) => {
                        if (!this.selectedRoleUsers.includes(String(item.userId))) {
                            this.selectedRoleUsers.push(String(item.userId));
                        }
                    });
                } else {
                    this.chooseAll = false;
                    this.deptUserData.forEach((item, index) => {
                        const filterIndex = this.selectedRoleUsers.findIndex(e => {
                            return e == item.userId;
                        });
                        this.selectedRoleUsers.splice(filterIndex, 1);
                    });
                }
                console.log(999, selection, this.selectedRoleUsers);
            },
            UserCurrentChange(val) {
                // console.log(`当前页: ${val}`);
                this.selectUser.current = val;
                this.getDeptUserData();
            },
            handleSizeChange(val) {
                // console.log(`每页: ${val}`);
                this.selectUser.pageSize = val;
                this.getDeptUserData();
            },
            getRoleUsersData() {
                const roleId = this.userPermissionTypeDialog.currentRoleId;
                getRoleUsers({roleId}).then(res => {
                    if (res.data.code == 0) {
                        this.selectedRoleUsers = res.data.data;
                        // this.selectedRoleUsersArray = res.data.data;
                        this.getDeptUserData();
                    }
                });
            },
            getDeptUserData() {
                const current = this.selectUser.current;
                const size = this.selectUser.pageSize;
                const deptId = this.currentDeptId;
                const type = this.type == 0 ? 2 : 0;
                let params = {current, size, deptId, type};
                if (this.userName) {
                    params.name = this.userName;
                }
                getDeptUser(params).then(res => {
                    if (res.data.code == 0) {
                        this.deptUserData = res.data.data.records;
                        this.selectUser.total = res.data.data.total;
                        this.$nextTick(() => {
                            this.deptUserData.forEach(row => {
                                if (this.selectedRoleUsers.includes(String(row.userId))) {
                                    this.$refs.multipleRoleUserTable.toggleRowSelection(row, true);
                                }
                            });
                        });
                    }
                });
            },
            updateRoleUser() {
                const roleId = this.userPermissionTypeDialog.currentRoleId;
                const deptId = this.currentDeptId;
                const all = this.chooseAll;
                // const users = this.multipleDeptUser;
                const users = this.selectedRoleUsers;
                if (users.length < 1) {
                    this.$message.closeAll();
                    this.$message.warning("请选择用户");
                    return;
                }
                saveRoleUsers({roleId, deptId, all, users}).then(res => {
                    if (res.data.code == 0) {
                        this.$message.success("选择用户成功");
                        this.setPermissionDialog(false);
                    }
                });
            },
            userTypeSelectionChange(val) {
                const selectedArray = val.map(item => {
                    return item.value;
                });
                this.userTypeChecked = [].concat(selectedArray);
            },
            getRoleUserTypesData() {
                const roleId = this.userPermissionTypeDialog.currentRoleId;
                getRoleUserTypes({roleId}).then(res => {
                    // console.log("获取用户角色类型数据:", res);
                    if (res.data.code == 0) {
                        // this.depIdsArray = res.data.data.depIds;
                        this.utypesArray = res.data.data.utypes;
                        this.$nextTick(() => {
                            this.userTypes.forEach(row => {
                                const checked = this.utypesArray.includes(String(row.value))
                                    ? true
                                    : false;
                                this.$refs.multipleRoleUserType.toggleRowSelection(row, checked);
                            });
                            this.setDefaultChecked(res.data.data.depIds);
                        });
                    }
                });
            },
            updateRoleUserType() {
                const roleId = this.userPermissionTypeDialog.currentRoleId;
                const deptIds = this.checkedArray.join(",");
                const usertypes = this.userTypeChecked.join(",");
                // console.log(111, this.checkedArray);
                if (this.checkedArray.length < 1) {
                    this.$message.closeAll();
                    this.$message.warning("请选择部门");
                    return;
                }
                if (this.userTypeChecked.length < 1) {
                    this.$message.closeAll();
                    this.$message.warning("请选择用户类型");
                    return;
                }
                saveRoleUserTypes({roleId, deptIds, usertypes}).then(res => {
                    // console.log("保存用户类型数据：", res);
                    if (res.data.code == 0) {
                        this.$message.success("修改用户类型成功");
                        this.setPermissionDialog(false);
                    }
                });
            }
        }
    };
</script>
<style lang="less">
</style>
